import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "o-grid" }
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--4-1024 o-grid__cell--12-360" }
const _hoisted_3 = {
  key: 0,
  class: "u-text-align-special u-mar-0"
}
const _hoisted_4 = {
  key: 1,
  class: "u-text-align-special u-mar-0"
}
const _hoisted_5 = { class: "o-grid__cell o-grid__cell--6-1024 o-grid__cell--12-360" }
const _hoisted_6 = {
  key: 4,
  class: "gev19-infobox--blue"
}
const _hoisted_7 = {
  key: 5,
  class: "gev19-infobox--blue"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_SanierungsfragenElement = _resolveComponent("SanierungsfragenElement")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ueberschrift, { titel: "Angaben zur Sanierung" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.aelterAls50)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Welche der hier aufgelisteten Elemente wurden unter fachmännischer Ausführung in welchem Jahr komplett erneuert? "))
          : _createCommentVNode("", true),
        (!_ctx.aelterAls50)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Die Dacheindeckung wurde unter fachmännischer Ausführung komplett erneuert "))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_SanierungsfragenElement, {
          jahrChecked: _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.dachbedeckung,
          "onUpdate:jahrChecked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.dachbedeckung) = $event)),
          jahr: _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.dachbedeckungJahr,
          "onUpdate:jahr": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.dachbedeckungJahr) = $event)),
          name: 'Dachdeckung',
          infoText: 'An der Dachkonstruktion, der Dachhaut und der Dachdeckung wurden Renovierungsarbeiten durchgeführt.',
          fehler: _ctx.fehler,
          sanierungsfrage: {
          nameCheckbox: 'frage1Checkbox',
          nameInput: 'frage1Input',
        },
          "schmales-label": !(_ctx.aelterAls50 || _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.kernsanierungDurchgefuehrt)
        }, null, 8, ["jahrChecked", "jahr", "fehler", "schmales-label"]),
        (_ctx.aelterAls50 || _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.kernsanierungDurchgefuehrt)
          ? (_openBlock(), _createBlock(_component_SanierungsfragenElement, {
              key: 0,
              jahrChecked: _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.rohreGebaeude,
              "onUpdate:jahrChecked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.rohreGebaeude) = $event)),
              jahr: _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.rohreGebaeudeJahr,
              "onUpdate:jahr": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.rohreGebaeudeJahr) = $event)),
              name: 'Rohre der Wasserver-/Entsorgung im Gebäude',
              infoText: 
          'Die Grundvoraussetzung ist die komplette Erneuerung der Zu- und Ableitungsrohre inklusive der ' +
          'dazugehörigen Armaturen.'
        ,
              fehler: _ctx.fehler,
              sanierungsfrage: {
          nameCheckbox: 'frage2Checkbox',
          nameInput: 'frage2Input',
        }
            }, null, 8, ["jahrChecked", "jahr", "fehler"]))
          : _createCommentVNode("", true),
        (_ctx.aelterAls50 || _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.kernsanierungDurchgefuehrt)
          ? (_openBlock(), _createBlock(_component_SanierungsfragenElement, {
              key: 1,
              jahrChecked: _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.rohreAusserhalb,
              "onUpdate:jahrChecked": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.rohreAusserhalb) = $event)),
              jahr: _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.rohreAusserhalbJahr,
              "onUpdate:jahr": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.rohreAusserhalbJahr) = $event)),
              name: 'Rohre der Wasserver-/Entsorgung außerhalb des Gebäudes',
              infoText: 
          'Abwasserführende Rohre außerhalb des Gebäudes wurden erneuert bzw. es wurde in den letzten 10 ' +
          'Jahren eine Dichtheitsprüfung nachweislich durchgeführt'
        ,
              fehler: _ctx.fehler,
              sanierungsfrage: {
          nameCheckbox: 'frage3Checkbox',
          nameInput: 'frage3Input',
        }
            }, null, 8, ["jahrChecked", "jahr", "fehler"]))
          : _createCommentVNode("", true),
        (_ctx.aelterAls50 || _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.kernsanierungDurchgefuehrt)
          ? (_openBlock(), _createBlock(_component_SanierungsfragenElement, {
              key: 2,
              jahrChecked: _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.leitungenElektrik,
              "onUpdate:jahrChecked": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.leitungenElektrik) = $event)),
              jahr: _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.leitungenElektrikJahr,
              "onUpdate:jahr": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.leitungenElektrikJahr) = $event)),
              name: 'Elektrische Leitungen und Installationen',
              infoText: 
          'Die elektrischen Leitungen des gesamten Gebäudes wurden in einen neuwertigen Zustand versetzt. ' +
          'Dazu gehören auch alle Schalter und Sicherungseinrichtungen des Hauses.'
        ,
              fehler: _ctx.fehler,
              sanierungsfrage: {
          nameCheckbox: 'frage4Checkbox',
          nameInput: 'frage4Input',
        }
            }, null, 8, ["jahrChecked", "jahr", "fehler"]))
          : _createCommentVNode("", true),
        (_ctx.aelterAls50 || _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.kernsanierungDurchgefuehrt)
          ? (_openBlock(), _createBlock(_component_SanierungsfragenElement, {
              key: 3,
              jahrChecked: _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.leitungenHeizung,
              "onUpdate:jahrChecked": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.leitungenHeizung) = $event)),
              jahr: _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.leitungenHeizungJahr,
              "onUpdate:jahr": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.leitungenHeizungJahr) = $event)),
              name: 'Heizungsleitungen',
              infoText: 
          'Die Heizungsanlage des Gebäudes wurde komplett saniert. Dazu gehört, dass Heizkessel und ' +
          'Brenner nachweislich rundum ereuert wurden.'
        ,
              fehler: _ctx.fehler,
              sanierungsfrage: {
          nameCheckbox: 'frage5Checkbox',
          nameInput: 'frage5Input',
        }
            }, null, 8, ["jahrChecked", "jahr", "fehler"]))
          : _createCommentVNode("", true),
        (!_ctx.piniaStore.state.isMakler && _ctx.aelterAls50)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[10] || (_cache[10] = [
              _createElementVNode("strong", null, "Hinweis:", -1),
              _createTextVNode(" Haben die Maßnahmen in unterschiedlichen Jahren stattgefunden oder sind Sie sich beim Ausfüllen unsicher, rufen Sie uns gerne an. Sie erreichen unser Beratungsteam unter "),
              _createElementVNode("strong", null, [
                _createElementVNode("a", { href: "tel:+494037663366" }, "040 37663-366")
              ], -1),
              _createTextVNode(". ")
            ])))
          : _createCommentVNode("", true),
        (!_ctx.piniaStore.state.isMakler && !_ctx.aelterAls50)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[11] || (_cache[11] = [
              _createElementVNode("strong", null, "Hinweis:", -1),
              _createTextVNode(" Sind Sie sich beim Ausfüllen unsicher, rufen Sie uns gern an. Sie erreichen unser Beratungsteam unter "),
              _createElementVNode("strong", null, [
                _createElementVNode("a", { href: "tel:+494037663366" }, "040 37663-366")
              ], -1),
              _createTextVNode(". ")
            ])))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}